import { Trash2, Square, Send, Loader2 } from 'lucide-react';
import type { EstadoGravador } from '@/hooks/useGravadorAudio';
import { formatarDuracao } from '@/lib/audio-mp3';

interface GravadorAudioBarProps {
  estado: EstadoGravador;
  tempo: number;
  previewUrl: string | null;
  enviando: boolean;
  onParar: () => void;
  onCancelar: () => void;
  onEnviar: () => void;
}

export function GravadorAudioBar({
  estado, tempo, previewUrl, enviando, onParar, onCancelar, onEnviar,
}: GravadorAudioBarProps) {
  if (estado === 'convertendo') {
    return (
      <div className="gravador">
        <Loader2 size={16} className="animate-spin" />
        <span className="gravador__tempo">A preparar…</span>
      </div>
    );
  }
  if (estado === 'pronto') {
    return (
      <div className="gravador">
        <button type="button" className="gravador__btn" aria-label="cancelar gravação" onClick={onCancelar}>
          <Trash2 size={18} />
        </button>
        {previewUrl && <audio controls src={previewUrl} className="gravador__player" />}
        <button type="button" className="gravador__btn gravador__btn--enviar" aria-label="enviar áudio" disabled={enviando} onClick={onEnviar}>
          <Send size={18} />
        </button>
      </div>
    );
  }
  // gravando
  return (
    <div className="gravador">
      <button type="button" className="gravador__btn" aria-label="cancelar gravação" onClick={onCancelar}>
        <Trash2 size={18} />
      </button>
      <span className="gravador__dot" aria-hidden />
      <span className="gravador__tempo">{formatarDuracao(tempo)}</span>
      <span className="gravador__spacer" />
      <button type="button" className="gravador__btn gravador__btn--enviar" aria-label="parar gravação" onClick={onParar}>
        <Square size={18} />
      </button>
    </div>
  );
}
